import { createSafeContext } from '@mews/framework';

export interface FetchingContextProps {
    setFetching: (state: boolean) => void;
}

export const { FetchingContextProvider, useFetchingContext } = createSafeContext<
    'FetchingContext',
    FetchingContextProps
>('FetchingContext');
